var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"data-component":"nav-menu"}},_vm._l((_vm.getLinks),function(link,key){return _c('router-link',{key:key,attrs:{"to":link.route}},[_vm._v(" "+_vm._s(link.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }